import React from "react";
import { ReactQueryDevtools } from "react-query/devtools";

import { useAuth } from "./auth";
import MainLayout from "./components/main-layout";
const AuthenticatedApp = React.lazy(() => import("./app/authenticated"));
const UnauthenticatedApp = React.lazy(() => import("./app/unauthenticated"));

const App = () => {
    const { user } = useAuth();
    return (
        <MainLayout>
            {user ? <AuthenticatedApp /> : <UnauthenticatedApp />}
            <ReactQueryDevtools initialIsOpen={false} />
        </MainLayout>
    );
};

export default App;
